import React, { useEffect, useRef, useState } from 'react'
import Navbar from '../../components/Navbar'
import Sidebar from '../../components/Sidebar'
import {QRCodeSVG} from 'qrcode.react';
import LoadingScreen from '../../components/LoadingScreen';

const PlanView = () => {
   
  const [qrCodeSvg, setQrCodeSvg] = useState('');
  const qrCodeUrl = "http://localhost:3001/plan-view"; // QR Code URL
 
  // Function to extract the full SVG code after 2 seconds
  useEffect(() => {

      const svgElement = document.getElementById("myqr");

      // If the SVG element is found, get its full outer HTML (i.e., the complete SVG code)
      if (svgElement) {
          const svgCode = svgElement.outerHTML;
          setQrCodeSvg(svgCode)
          console.log('svgCode',svgCode); // Output the full SVG code to the console
      } else {
          console.log("SVG element not found");
      }
    }, []);




  return (
    <>

    <Sidebar />
    <main class="content">
      <Navbar />


      {/* <div className="py-4">
<div className='container'>
    <div className="border bg-white ">
        <div className='d-flex justify-content-between position-relative' >
        <div className='col-7 p-4'>
        <img src="https://backend-2o7f.onrender.com/uploads/new/image-1726306777273.webp" className='w-100' style={{maxWidth:400}}/>
        <div className='p-4 mycard-body'>
<h6 class="head-theme" >Cashless Home Healthcare Card</h6>
<ul class="mytheme-ul">
  <li>
  Home Healthcare Services, like Medical Equipment on Rental, ICU Setup at Home, Ambulance Services, Dead Body Freezer Box Rental (up to ₹50,000/- cashless)	
  </li>
  <li>
  Full Body Health Checkup Free Every Year	
  </li>
  <li>
  IPD (Hospital Admissions) – 10% Off on Total Bill	
  </li>
  <li>
  OPD (Online Doctor Consultation) – Unlimited Free	
  </li>
  <li>
  Pathology (Blood Tests) – 10% to 25% Off on Total Bill	
  </li>
  <li>
  Diagnostics – X-Ray / USG / MRI / CT Scan – 10% Off	
  </li>
  <li>
  Ayurveda Treatment – 10% Off	
  </li>
  <li>
    Dental Health – 10% Off	

  </li>
</ul>
        </div>

        </div>
        <div className="col round-ribbon">
<img src="/assets/images/ribbon.webp" style={{width:'60%'}} className='d-block ms-auto'/>
<div className='p-4'>
<div className='ribbon-text'>
   <p className='text-white m-0'> Gift for your</p> <h4 className='m-0 text-white h1 fw-extrabold'> Health</h4></div>
   <QRCodeSVG value="http://localhost:3001/plan-view" className='p-2 bg-white '  /> 


</div>

        </div>

        <div className='ribbon-price'>
    <h4><span className='fw-light h6 d-block'>Only</span> 2999/-  <span className='fw-light h6 d-block' >  for </span> 1 year   <span className='fw-light h6 d-block'>  Validity </span> </h4> 
    </div>

        </div>

      
      
    </div>
</div>
        </div> */}

<QRCodeSVG value={qrCodeUrl} className="p-2 bg-white position-absolute invisible"  id="myqr" />

{qrCodeSvg !== '' ? 
  <iframe
 srcDoc={`
   <link rel='stylesheet' href='http://localhost:3001/assets/css/volt.css'/>
   <style>
     body, html {
       margin: 0;
       padding: 0;
       width: 100%;
       height: 100%;
       overflow: scroll;
     }
     .container {
       width: 1024px; /* Set the width to your preferred desktop size */
       margin: 0 auto; /* Center the content */
     }
     img {
       max-width: 100%; /* Ensure images scale correctly */
       height: auto;
     }
       #myqr{visibility: visible !important;position:relative !important;}
   </style>
   <div class='py-4'>
     <div class='container'>
       <div class='border bg-white'>
         <div class='d-flex justify-content-between position-relative'>
           <div class='col-7 p-4'>
             <img src='https://backend-2o7f.onrender.com/uploads/new/image-1726306777273.webp' class='w-100' style='max-width:400px;' />
             <div class='p-4 mycard-body'>
               <h6 class='head-theme'>Cashless Home Healthcare Card</h6>
               <ul class='mytheme-ul'>
                 <li>Home Healthcare Services, like Medical Equipment on Rental, ICU Setup at Home, Ambulance Services, Dead Body Freezer Box Rental (up to ₹50,000/- cashless)</li>
                 <li>Full Body Health Checkup Free Every Year</li>
                 <li>IPD (Hospital Admissions) – 10% Off on Total Bill</li>
                 <li>OPD (Online Doctor Consultation) – Unlimited Free</li>
                 <li>Pathology (Blood Tests) – 10% to 25% Off on Total Bill</li>
                 <li>Diagnostics – X-Ray / USG / MRI / CT Scan – 10% Off</li>
                 <li>Ayurveda Treatment – 10% Off</li>
                 <li>Dental Health – 10% Off</li>
               </ul>
             </div>
           </div>
           <div class='col round-ribbon'>
             <img src='/assets/images/ribbon.webp' style='width:60%' class='d-block ms-auto' />
             <div class='p-4'>
               <div class='ribbon-text'>
                 <p class='text-white m-0'>Gift for your</p>
                 <h4 class='m-0 text-white h1 fw-extrabold'>Health</h4>
               </div>
               <!-- Insert the generated QR code image -->
              ${qrCodeSvg}
             </div>
           </div>
           <div class='ribbon-price'>
             <h4><span class='fw-light h6 d-block'>Only</span> 2999/- <span class='fw-light h6 d-block'> for </span> 1 year <span class='fw-light h6 d-block'> Validity </span></h4>
           </div>
         </div>
       </div>
     </div>
   </div>
 `}
 style={{ width: '100%', height: '90vh' }}
/>
: <LoadingScreen/>
}
   
      
        </main>
       
        </>
  )
}

export default PlanView